export enum HsaDecisionMethod {
  TermList = "term_list",
  Jev = "jev",
  Llm = "llm",
  Admin = "admin",
  CatalogEligibility = "catalog_eligibility",
}
